import AuthorCard from './_AuthorCard';
import RecipeCard from './_RecipeCard';
import StoryCard from './_StoryCard';
import CalloutGridCard from '@repo/ui/src/components/CalloutGridCard';
import { classNames } from '@repo/ui/src/utils/classNames';
import {
  AuthorProps,
  MediaType,
  ImageProps,
  MetaProps,
  RecipeMetaSectionProps,
  ToutContentProps,
  YoutubeLinkProps,
} from '@repo/ui/src/types';

interface CascadingCardProps {
  _testID: string;
  card: {
    avatar?: MediaType;
    featuredQuote?: string;
    id?: string;
    name?: string;
    author?: AuthorProps;
    assets?: Array<{
      endpoint: string;
      name: string;
    }>;
    toutContent: ToutContentProps;
    linkLabel?: string;
    recipeMetaSection?: RecipeMetaSectionProps;
    _meta: MetaProps;
    actionText?: string;
    categories?: any;
    description?: string;
    fullWidth?: boolean;
    image: ImageProps;
    title?: string;
    youtubeLink?: YoutubeLinkProps;
  };
  className: string;
  i: number;
  staticContent?: {
    author: {
      heading: string;
      link: string;
    };
    story: {
      heading: string;
      link: string;
      playButtonLabel: string;
    };
    recipe: {
      by: string;
      cookTimeLabel: string;
      effort: string;
      heading: string;
      link: string;
      prepTimeLabel: string;
    };
  };
}

const CascadingCard = ({ card, i, staticContent, className, _testID }: CascadingCardProps) => {
  const alignRight = i  % 2 !== 0;

  if (!card?._meta) return null;

  const getSchemaType = (schema: string) => {
    const parts = schema.split('/');
    return parts[parts.length - 1] || '';
  };

  const schemaType = getSchemaType(card._meta.schema);
  const calloutCard = schemaType === 'calloutGridCard.json';

  const getCard = () => {
    switch (schemaType) {
      case 'author.json':
        return <AuthorCard {...card} {...staticContent?.author} />;
      case 'story.json':
        return <StoryCard {...card} {...staticContent?.story}  />;
      case 'recipe.json':
        return <RecipeCard {...card} {...staticContent?.recipe} />;
      case 'calloutGridCard.json':
        return <CalloutGridCard {...card} _testID={_testID} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(
        "tw-relative tw-z-[1] tw-bg-warm-200 tw-text-left tw-min-h-[140vw] tw-mb-4",
        "sm:tw-min-h-[50vw] tw-mb-[1.5rem]",
        "md:tw-w-[80%] md:tw-max-w-[1280px] md:tw-min-h-[40vw] md:tw-mb-[-3.2vw]",
        "xl:tw-min-h-[720px] xl:tw-h-[720px] last:tw-mb-0",
        alignRight ? 'tw-ml-auto tw-mr-0' : 'tw-ml-0 tw-mr-auto',
        calloutCard && '[&>*]:tw-min-h-[inherit] [&>*>*]:tw-min-h-[inherit]',
        className,
      )}
    >
      {getCard()}
    </div>
  );
};

export default CascadingCard;
